import axios from 'smg/axios';
import * as models from 'smg/customer-api/models';
import { CustomerAPIV2Root } from 'smg/customer-api/v2';
import * as template from 'smg/template';

import { Uploader } from '../../../components/uploader';

import { State } from '../../state';
import { Payment } from '../../types';

import { BindBackLink, EnsurePurchaseOrder, PromoteFormBodyIDs, SetupBillingAddress } from './shared';

// RenderPoForm replaces $el with the purchase-order form, mounts an
// Uploader for supporting documents, and wires PO number + upload IDs
// into state.payment.purchaseOrder. When uploadIDs is provided, the server
// is asked to keep those existing uploads alive first.
export function RenderPoForm(state: State, $el: HTMLElement, back: () => void, uploadIDs?: number[]): void {
    const { dom } = state;
    $el.replaceChildren(template.Clone('#payment-option-form-new-po'));
    PromoteFormBodyIDs($el);
    SetupBillingAddress(state, $el);
    state.initPaymentTypeSelect(models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PO, $el);
    BindBackLink($el, back);

    const syncUploadIDs = async () => {
        const p = state.payment;
        if (p.uploader?.getUploads().length) {
            $el.querySelector<HTMLInputElement>('.po-num')?.setCustomValidity('');
            // allowPartial: background sync fired from onidschange/onchange,
            // unawaited. A failed PUT re-fires onidschange and this re-syncs
            // the survivors, so throwing would only produce an unhandled
            // rejection.
            EnsurePurchaseOrder(p).purchaseOrderUploadIDs = await p.uploader.getUploadIDs({ allowPartial: true });
        } else {
            $el.querySelector<HTMLInputElement>('.payment-option-uploader')?.setCustomValidity('Please upload a file');
        }
    };

    // To reload uploads by ID later, we must patch keep=true on the server first.
    const prep = uploadIDs ? axios.patch('/uploads/keep', { uploadIDs }, { baseURL: CustomerAPIV2Root() }) : Promise.resolve();
    void prep.then(() => {
        state.payment.uploader = new Uploader($el.querySelector('.uploader-dropzone') as HTMLLabelElement, {
            confirmBtn: dom.$paymentBody?.querySelector<HTMLButtonElement>('#payment-option-confirm') ?? undefined,
            uploadIDs,
            onidschange: syncUploadIDs,
            onchange: syncUploadIDs,
        });
        $el.querySelector<HTMLInputElement>('.po-num')?.addEventListener('input', () => {
            EnsurePurchaseOrder(state.payment).purchaseOrderNumber = $el.querySelector<HTMLInputElement>('.po-num')?.value || '';
        });
    });
}

// RefillPoFields re-populates the PO number input from state.payment —
// used when resuming an in-progress PO entry after a failed confirm.
export function RefillPoFields(p: Payment, $el?: HTMLElement): void {
    // #po-num is promoted to .po-num by PromoteFormBodyIDs.
    const $poNum = $el?.querySelector<HTMLInputElement>('.po-num');
    if ($poNum) {
        $poNum.value = p.purchaseOrder?.purchaseOrderNumber || '';
    }
}
